export default "__VITE_ASSET__KTpSrN65__"